// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1SugM","buttonInverted":"Button_buttonInverted__kVLA5"};